import { Dispatch, ForwardedRef, forwardRef, SetStateAction } from 'react';
import { HeaderGroup } from 'react-table';

import styled, { isPropValid } from '@mint-lib/styled';

import { VERSION_ROW_TYPES } from '../../../../../constants/versionsColumnsObject.js';
import { useTableScale } from '../../../../../hooks/useTableScale.js';
import VersionsTableHeadItem from './VersionsTableHeadItem/index.jsx';

type Props = {
  headerGroups: HeaderGroup<object>[];
  expandedType: VERSION_ROW_TYPES;
  setExpandedType?: Dispatch<SetStateAction<VERSION_ROW_TYPES>>;
};

const VersionsTableHead = forwardRef(
  (
    { headerGroups, expandedType, setExpandedType }: Props,
    headRef: ForwardedRef<HTMLTableRowElement>,
  ) => {
    const scale = useTableScale();

    return (
      <Thead>
        {headerGroups.map((headerGroup) => (
          <Tr
            {...headerGroup.getHeaderGroupProps()}
            $zIndex={headerGroup.headers.length}
            className="tr"
            $scale={scale}
            ref={headRef}
          >
            {headerGroup.headers.map((header, idx) => (
              <VersionsTableHeadItem
                header={header}
                key={header.id}
                headerIdx={headerGroup.headers.length - idx}
                expandedType={expandedType}
                setExpandedType={setExpandedType}
              />
            ))}
          </Tr>
        ))}
      </Thead>
    );
  },
);

const Thead = styled('div')`
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 3;
`;

const Tr = styled('div', { shouldForwardProp: isPropValid })<{
  $zIndex: number;
  $scale: number;
}>`
  display: flex;
  align-items: flex-start;
  height: ${({ $scale }) => $scale * 40}px;

  & > .th {
    position: sticky;
    top: 0;
    border-right: 1px solid ${({ theme }) => theme.palette.border.secondary};
    border-bottom: 1px solid ${({ theme }) => theme.palette.border.secondary};
    &:first-of-type {
      border-top-left-radius: 6px;
    }

    &:last-child {
      width: 47px;
      z-index: ${({ $zIndex }) => $zIndex} !important;
      border-left: 1px solid ${({ theme }) => theme.palette.border.secondary};
      background-color: ${({ theme }) => theme.palette.background.default};
      pointer-events: auto !important;
    }

    &:nth-last-child(2) {
      border-right: none;
    }
  }
`;

export default VersionsTableHead;
